export default __webpack_public_path__ + "static/media/girl2x.8d605661.png";